export const isReAccommodation = (oldProduct, oldLeg, newProduct, newLeg) => {
  if (!oldProduct || !newProduct || !oldLeg || !newLeg) {
    return false;
  }

  if (oldProduct.cancelledRevision == null || newProduct.createdRevision == null) {
    return false;
  }

  const sameRevision = oldProduct.cancelledRevision === newProduct.createdRevision;
  const sameService = oldLeg.trainNumber === newLeg.trainNumber;
  const sameDate = oldLeg.timing?.isoDate === newLeg.timing?.isoDate;
  const sameClass = oldLeg.classOfService?.code === newLeg.classOfService?.code;

  return sameRevision && sameService && sameDate && sameClass;
};

export const hasExchangeInTicketChain = (legs = [], passengerId) => {
  if (!passengerId) return false;

  const passengerProducts = [];
  legs.forEach((leg) => {
    (leg.products || []).forEach((product) => {
      if (product.passengerId === passengerId) {
        passengerProducts.push({ product, leg });
      }
    });
  });

  if (passengerProducts.length === 0) return false;

  for (const current of passengerProducts) {
    if (current.product.cancelledRevision != null) {
      const replacement = passengerProducts.find((p) => p.product.createdRevision === current.product.cancelledRevision);

      if (replacement) {
        const isReaccom = isReAccommodation(current.product, current.leg, replacement.product, replacement.leg);
        if (!isReaccom) {
          return true;
        }
      }
    }
  }

  return false;
};

export const getPassengersWithExchangeInTicketChain = (legs = []) => {
  const passengersWithExchange = new Set();
  const passengerIds = new Set();

  legs.forEach((leg) => {
    (leg.products || []).forEach((product) => {
      if (product.passengerId) {
        passengerIds.add(product.passengerId);
      }
    });
  });

  passengerIds.forEach((passengerId) => {
    if (hasExchangeInTicketChain(legs, passengerId)) {
      passengersWithExchange.add(passengerId);
    }
  });

  return passengersWithExchange;
};
